import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import AutoCompleteMultiCheckbox from '../../../../components/AutoCompleteMultiCheckbox';
import Text from '../../../../components/Text';
import { GENDER, WT } from '../../../../comm/constant';
import { WarpSwitch } from '../../../../components/WarpSwitch';
import AeNoScanInput from '../AeNoScanInput';

const useStyles = makeStyles(() => ({
  reset: {
    color: '#538FFF',
    fontSize: '1rem',
    textDecoration: 'underline',
    fontFamily: 'NotoSans-Bold',
  },
  flexSpace: {
    display: 'block',
    minWidth: 0,
    flex: 1,

    [`@media (max-width: 1320px)`]: {
      display: 'none',
    },
  },
  showDetails: {
    fontSize: '1rem',
    color: '#3E3E3E',
    gap: '0.3rem',
    fontFamily: 'NotoSans-Medium',
    display: 'flex',
    alignItems: 'center',
  },
}));

const noop = () => {};
const defaultFilter = {
  aeNo: '',
  busstops: [],
  sex: '',
  specialtys: [],
  waitTime: 0,
};

// 给单选下拉补一个空选项。
const initItemList = (itemList) => {
  return [{ text: '', value: '' }, ...itemList];
};

const getSelectedOptions = (itemList, values) => {
  return _.map(values, (value) => _.find(itemList, (item) => item.value === value) ?? { text: value, value });
};

const getOptionValues = (options) => {
  return _.map(options, (item) => item.value);
};

// Location View共用的filter UI，固定使用AED/SOPD接口的filter字段。
export default function AdmissionLocationFilter({
  filter = defaultFilter,
  statisticData = null,
  onFilterChange = noop,
  specialtyList = [],
  genderList = GENDER,
  waitTimeList = WT,
  busstopList = [],
  onAeNoBarcodeScan = noop,
  isLoading = false,
  onReset = noop,
  showDetails = false,
  onShowDetailsChange = noop,
}) {
  const classes = useStyles();
  const form = { ...defaultFilter, ...filter };
  const specialtyValue = getSelectedOptions(specialtyList, form.specialtys);
  const busstopValue = getSelectedOptions(busstopList, form.busstops);
  const handleFilterChange = (key) => (value) => {
    onFilterChange({
      ...form,
      [key]: value,
    });
  };

  return (
    <Box display="flex" flexWrap="wrap" gridGap="0.75rem" alignItems="center" mb="0.2rem">
      <Text color="#3E3E3E" fontSize="1rem">
        Filter:
      </Text>
      <AutoCompleteMultiCheckbox
        itemList={specialtyList}
        value={specialtyValue}
        onChange={(value) => handleFilterChange('specialtys')(getOptionValues(value))}
        width="8rem"
        height="2.5625rem"
        placeholder="Specialty"
        freeSolo
        highlight="#FFFFCC"
        selectAll={false}
      />
      <AutoCompleteInput
        itemList={initItemList(genderList)}
        value={form.sex}
        onChange={handleFilterChange('sex')}
        width="6rem"
        height="2.5625rem"
        placeholder="Gender"
        highlight="#FFFFCC"
      />
      <AutoCompleteInput
        itemList={waitTimeList}
        value={String(form.waitTime ?? 0)}
        onChange={(value) => handleFilterChange('waitTime')(Number(value || 0))}
        width="6rem"
        height="2.5625rem"
        placeholder="W.T."
        highlight="#FFFFCC"
      />
      <AutoCompleteMultiCheckbox
        itemList={busstopList}
        value={busstopValue}
        onChange={(value) => handleFilterChange('busstops')(getOptionValues(value))}
        width="15rem"
        height="2.5625rem"
        placeholder="Bus Stop"
        freeSolo
        highlight="#FFFFCC"
        selectAll={false}
      />
      <AeNoScanInput
        value={form.aeNo}
        onChange={handleFilterChange('aeNo')}
        onBarcodeScan={onAeNoBarcodeScan}
        disabled={isLoading}
        highlight="#FFFFCC"
        width="10rem"
      />
      <Box className={classes.showDetails}>
        <Box>Show Details</Box>
        <WarpSwitch checked={showDetails} onChange={(event) => onShowDetailsChange(event.target.checked)} />
      </Box>
      <ButtonBase className={classes.reset} onClick={onReset}>
        Reset
      </ButtonBase>
      <Box className={classes.flexSpace} />
      <Text fontSize="1rem">
        Last updated time:{' '}
        {statisticData?.lastUpdatedTime && moment(statisticData?.lastUpdatedTime).format('YYYY-MM-DD HH:mm')}
      </Text>
    </Box>
  );
}
